import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import api from "services/api";
import { requireAuth } from "actions/AuthAction";
import JenisIzinFormDialog from "./components/JenisIzinFormDialog";
import JenisIzinDetailDialog from "./components/JenisIzinDetailDialog";

function AdminJenisIzin() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [formMode, setFormMode] = useState("create");
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);

  const loadData = useCallback(() => {
    setLoading(true);
    api
      .get("jenis-izin")
      .then((res) => setRows(res.data?.data || []))
      .catch(() => alert("Gagal memuat jenis izin"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!requireAuth(navigate, ["ADMIN", "SUPER_ADMIN"])) return;
    loadData();
  }, [navigate, loadData]);

  const openCreate = () => {
    setFormMode("create");
    setSelectedItem(null);
    setFormOpen(true);
  };

  const openEdit = (item) => {
    setFormMode("edit");
    setSelectedItem(item);
    setDetailOpen(false);
    setFormOpen(true);
  };

  const openDetail = (item) => {
    setSelectedItem(item);
    setDetailOpen(true);
  };

  const columns = [
    { Header: "Kode", accessor: "kode", width: "10%" },
    { Header: "Nama Layanan", accessor: "nama", width: "28%" },
    { Header: "Sektor", accessor: "sektor", width: "14%" },
    { Header: "Kategori", accessor: "kategori", width: "12%" },
    { Header: "Status", accessor: "status", width: "10%" },
    { Header: "Flags", accessor: "flags", width: "14%" },
    { Header: "Aksi", accessor: "action", align: "center" },
  ];

  const tableRows = rows.map((r) => ({
    kode: r.kode,
    nama: r.nama,
    sektor: r.sektor,
    kategori: r.kategori,
    status: (
      <Chip label={r.status} size="small" color={r.status === "AKTIF" ? "success" : "default"} />
    ),
    flags: (
      <MDBox display="flex" gap={0.5} flexWrap="wrap">
        {r.perlu_rekomendasi_teknis ? <Chip label="Teknis" size="small" /> : null}
        {r.perlu_pemeriksaan_lapangan ? <Chip label="Lapangan" size="small" color="warning" /> : null}
      </MDBox>
    ),
    action: (
      <MDBox display="flex" gap={0.5} justifyContent="center" flexWrap="wrap">
        <MDButton size="small" color="info" variant="text" onClick={() => openDetail(r)}>
          Detail
        </MDButton>
        <MDButton size="small" color="warning" variant="text" onClick={() => openEdit(r)}>
          Edit
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={2}>
          <MDBox>
            <MDTypography variant="h4">Kelola Jenis Izin</MDTypography>
            <MDTypography variant="button" color="text">
              Tambah, edit, dan kelola persyaratan layanan perizinan
            </MDTypography>
          </MDBox>
          <MDButton variant="gradient" color="info" onClick={openCreate}>
            + Tambah Jenis Izin
          </MDButton>
        </MDBox>

        <Card>
          <MDBox p={3}>
            {loading ? (
              <MDTypography>Memuat...</MDTypography>
            ) : (
              <DataTable table={{ columns, rows: tableRows }} canSearch entriesPerPage={{ defaultValue: 15 }} />
            )}
          </MDBox>
        </Card>
      </MDBox>
      <Footer />

      <JenisIzinFormDialog
        open={formOpen}
        mode={formMode}
        item={selectedItem}
        onClose={() => setFormOpen(false)}
        onSaved={loadData}
      />

      <JenisIzinDetailDialog
        open={detailOpen}
        item={selectedItem}
        onClose={() => setDetailOpen(false)}
        onEditJenis={openEdit}
      />
    </DashboardLayout>
  );
}

export default AdminJenisIzin;
